import React, { useState } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

const ProductFilters = ({ location, history }) => {

    const [selectedProductTypes, setSelectedProductTypes] = useState(["2","5"]);
    const qString = queryString.parse(location.search);
    
    const isSelectedProductType = (productType) => {
        return selectedProductTypes?.includes(productType?.toString()); 
    }

    const handleProductTypeFilter = (e) => {
        const isChecked = e.target.checked;
        const productType = e.target.value;
        const category = (qString.category || 'all');
        const search = (qString.search || '');
        let _selectedProductTypes = selectedProductTypes;
        if(isChecked){
            _selectedProductTypes = [...selectedProductTypes, productType];
        }else{
             _selectedProductTypes = selectedProductTypes?.filter(x => x !== productType);
        }
        setSelectedProductTypes(_selectedProductTypes);
        history.push(`/?page=&category=${category}&search=${search}&productTypes=${_selectedProductTypes?.toString()}`);
      }

    return(
        <div className="product-filters">
            <div className="product-filters-checkbox">
                <input type="checkbox" id="file-import" name="Fileimport" value="5" onChange={handleProductTypeFilter} checked={isSelectedProductType(5)}/>
                <label htmlFor="file-import">Filimport</label>
            </div>
            <div className="product-filters-checkbox">
                <input type="checkbox" id="Integrations" name="Integrasjoner" value="2" onChange={handleProductTypeFilter} checked={isSelectedProductType(2)} />
                <label htmlFor="Integrations">Integrasjoner</label>
            </div>
        </div>
    )
};

export default withRouter(ProductFilters);